"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const button_1 = require("../button");
const input_1 = require("../input");
const theme_1 = require("../theme");
const register_styled_1 = require("./register.styled");
const BlueButton = theme_1.default.presetTheme(button_1.default, {
    color: 'white',
    bgColor: theme_1.default.colours.primary.default,
    hoverColor: theme_1.default.colours.primary.dark,
    activeColor: theme_1.default.colours.primary.dark
});
exports.Register = ({ email: inEmail, name: inName, validate, onSubmit, loading, children }) => {
    const [email, setEmail] = React.useState(inEmail || '');
    const [name, setName] = React.useState(inName || '');
    const [liveValidate, setLiveValidate] = React.useState(false);
    const validation = validate ? validate({ email, name }) : { email: '', name: '' };
    return React.createElement(register_styled_1.default, null,
        React.createElement("form", { className: "register", onSubmit: (e) => { e.preventDefault(); setLiveValidate(true); onSubmit({ email, name }); } },
            React.createElement("div", { className: "register__row" },
                React.createElement("label", { className: "register__label", htmlFor: "name" }, "Name"),
                React.createElement(input_1.default, { invalid: liveValidate ? !!validation.name : false, required: true, type: "text", id: "name", value: name, onChange: (e) => setName(e.target.value) }),
                liveValidate && validation.name && React.createElement("span", { className: "register__error" }, validation.name)),
            React.createElement("div", { className: "register__row" },
                React.createElement("label", { className: "register__label", htmlFor: "email" }, "Email"),
                React.createElement(input_1.default, { invalid: liveValidate ? !!validation.email : false, required: true, type: "email", id: "email", value: email, onChange: (e) => setEmail(e.target.value) }),
                liveValidate && validation.email && React.createElement("span", { className: "register__error" }, validation.email)),
            React.createElement("div", { className: "register__button" },
                React.createElement(BlueButton, { loading: loading }, "Sign up for free"),
                React.createElement("p", { className: "register__disclaimer" }, "By selecting 'Sign up for free', you allow TravelNest to contact you about their products")),
            children && React.createElement("div", { className: "register__children" }, children)));
};
//# sourceMappingURL=Register.js.map